import { render, staticRenderFns } from "./session-refresh.vue?vue&type=template&id=8a9ddf48&"
import script from "./session-refresh.vue?vue&type=script&lang=js&"
export * from "./session-refresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports